/**
 * ログイン情報
 */
export class LoginInfo {
	// private変数 --------------------------------------------------------
	private m_LoginId: string = null; // ログインID
	private m_LoginPass: string = null; // パスワード
	private m_LoginPassAgain: string = null; // パスワード（再入力）
	// --------------------------------------------------------------------

	// プロパティ --------------------------------------------------------------------
	/** ログインID */
	public get loginId(): string { return this.m_LoginId; } public set loginId(loginId: string) { this.m_LoginId = loginId; }
	/** パスワード */
	public get loginPass(): string { return this.m_LoginPass; } public set loginPass(loginPass: string) { this.m_LoginPass = loginPass; }
	/** パスワード */
	public get loginPassAgain(): string { return this.m_LoginPassAgain; } public set loginPassAgain(loginPassAgain: string) { this.m_LoginPassAgain = loginPassAgain; }
	// --------------------------------------------------------------------

	// コンストラクタ --------------------------------------------------------
	constructor() { }
	// ------------------------------------------------------------------------
}